import { createFileRoute } from '@tanstack/react-router';
import { LegacyCompanyWorkflowPage } from '@/features/parties/LegacyCompanyWorkflowPage';

export const Route = createFileRoute('/app/companies')({ component: LegacyCompanyWorkflowPage });
